import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <div className='footer'>
      <div className='footer-image'>
        <img src='assets/slogo.png' alt='logo'/>
        <div className='footertext' style={{color: "white"}}>© 2024 All Rights Reserved. Developed By IIT Madras.</div>
      </div>
    </div>
  )
}

export default Footer
